import { convertAreaLabel } from '~/models/area'
import { licenseTypeLabel } from '~/models/licenseType'
import type { SubmitterMasterRow } from '~/pages/AdminOcctoMaster/tabs/SubmitterMaster/hooks/useListSubmitterMasters'
import type { CsvColumnDef } from '~/pages/AdminOcctoMaster/tabs/_common/models/csvExport'

/**
 * 計画提出者マスタタブの CSV エクスポート カラム定義
 * (spec AC-012b / design doc §5「タブ別 CSV カラム」)。
 */
export function submitterMasterCsvColumns(): Array<
  CsvColumnDef<SubmitterMasterRow>
> {
  return [
    {
      headerKey: 'page:adminOcctoMaster.submitterMaster.column.submitterCode',
      accessor: (row) => row.submitterCode,
    },
    {
      headerKey: 'page:adminOcctoMaster.submitterMaster.column.submitterName',
      accessor: (row) => row.submitterName,
    },
    {
      headerKey: 'page:adminOcctoMaster.submitterMaster.column.licenseType',
      accessor: (row) => licenseTypeLabel(row.licenseType),
    },
    {
      headerKey: 'page:adminOcctoMaster.submitterMaster.column.areaCode',
      accessor: (row) => convertAreaLabel(row.areaCode),
    },
    {
      headerKey: 'page:adminOcctoMaster.submitterMaster.column.memberCount',
      accessor: (row) => String(row.memberCount),
    },
  ]
}
